import { createStore } from "vuex";
import configure from "./configure";
import user from "./user";
import song from "./song";
import VuexPersist from 'vuex-persist';
import Vuex from 'vuex'

// export default createStore({
//   modules: {
//     configure,
//     user,
//     song,
//   },
// });

const vuexLocal = new VuexPersist({
  storage: window.localStorage  // 可选存储方式
})
export default new Vuex.Store({
  modules: {
    configure,
    user,
    song,
  },
  // 引入 vuex-persist 插件
  plugins: [vuexLocal.plugin]
})